import './lucys/style';
import FormStructure from './lucys/form_structure';

export default FormStructure;